import { Fragment } from 'react';
import ContentBlocks from './index';
import type {
  TreatmentPageCostsCollection,
  TreatmentPageDetailsCollection,
  TreatmentPageOverviewCollection,
  TreatmentPageReviewsCollection,
} from 'types/contentful/generated/graphql';

export type Block = {
  __typename: string;
  disableLocale: boolean;
  sys: {
    id: string;
    contentType: {
      sys: {
        id: string;
        linkType: string;
        type: string;
      };
    };
  };
  fields: {
    disableLocale?: boolean;
  };
};

type Props = {
  entry?:
    | TreatmentPageCostsCollection
    | TreatmentPageDetailsCollection
    | TreatmentPageOverviewCollection
    | TreatmentPageReviewsCollection
    | null;
};

const BlockLoader = ({ entry }: Props): JSX.Element => {
  return (
    <>
      {entry?.items?.map((block, i) => {
        if (!block?.__typename) {
          return;
        }

        if ('disableLocale' in block && block.disableLocale) {
          return;
        }

        return (
          <Fragment key={i}>
            <ContentBlocks type={block.__typename} fields={block} />
          </Fragment>
        );
      })}
    </>
  );
};

export default BlockLoader;
